import React, { Fragment } from 'react';
import Container from 'react-bootstrap/Container';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';

import Card from 'react-bootstrap/Card';
/*
 Takes a prop of data, which is an object.
 Example:

{"SecId":"60052417",
"Index_Fund":"No",
"Name":"JPM China D Acc USD",
"Fund_Size_USD":"NULL",
"KIID_Ongoing_Charge":"NULL",
"Fee_Percentile":"NULL",
"Global_Category":"Global Emerging Markets Equity",
"Total_Ret_1_Yr__Mo_End__USD":0.749,
"Total_Ret_Annlzd_3_Yr__Mo_End__USD":0.275,
"Total_Ret_Annlzd_5_Yr__Mo_End__USD":0.313,
"Std_Dev_1_Yr__Mo_End__USD":0.285,
"Std_Dev_3_Yr__Mo_End__USD":0.252,
"Std_Dev_5_Yr__Mo_End__USD":0.22,
"RAR_1_year":0.026,
"Relative_RAR_1_year":-0.001,
"RAR_3_year":0.011,
"Relative_RAR_3_year":0,
"RAR_5_year":0.014,
"Relative_RAR_5_year":0.002,
"Weighted_Performance":0,
"RAR_1_year_percentile":0.993,
"Relative_RAR_1_year_percentile":0.996,
"RAR_3_year_percentile":0.985
,"Relative_RAR_3_year_percentile":0.973
,"RAR_5_year_percentile":0.988,
"Relative_RAR_5_year_percentile":0.979,
"_5_Yr_Risk_Percentile":0,
"Weighted_Performance_Percentile":0.979,
"Weighted_Total_Returns":0.381,
"Weighted_Standard_Deviation":0.249,
"_1_Yr_Net_Return":-0.248,
"_3_Yr_Net_Return":-0.141,
"_5_Yr_Net_Return":0.044,
"Weighted_Net_Return":-0.107,
"_5_Year_Added_Value":-0.005,
"_95":3,
"_9":3,
"_85":3,
"_8":3,
"consistency":5,
"performance":5,
"Year":"27/01/21"}

*/

// Uaing cols and rows
/*
const PercentileItem = ({label, percentile}) => {
  let ret = <span></span>;
  if (percentile > 0 ) {
    ret = <Col>{label}<sup class="fs-4">{percentile}</sup>&frasl;<sub class="fs-6">100</sub></Col>;
  };
  return ret;
};
*/

// Using the bootstrap Card. https://react-bootstrap.github.io/docs/components/cards
const PercentileItem = ({ label, percentile }) => {

  const labelMap = (inLabel) => {
    let ret = inLabel;
    if (inLabel === "1 Year RAR") {ret = "1 Year Risk Adjusted Return"};
    if (inLabel === "Relative 1 Year RAR") {ret = "Relative 1 Year Risk Adjusted Return"};
    if (inLabel === "3 Year RAR") {ret = "3 Year Risk Adjusted Return"};
    if (inLabel === "Relative 3 Year RAR") {ret = "Relative 3 Year Risk Adjusted Return"};
    if (inLabel === "5 Year RAR") {ret = "5 Year Risk Adjusted Return"};
    if (inLabel === "Relative 5 Year RAR") {ret = "Relative 5 Year Risk Adjusted Return"};
    return ret;
  };

  const titleStyle = {
    "fontSize":"0.8rem",
    "minHeight":"50px"
  };

  const numberStyle = {
    "background": "black",
    "borderRadius": "50%",
    "mazBorderRadius": "50%",
    "WebkitBorderRadius": "50%",
    "color": "white",
    "display": "inline-flex", // Use inline-flex for centering
    "justifyContent": "center", // Center the content horizontally
    "alignItems": "center",    // Center the content vertically
    "fontWeight": "bold",
    "lineHeight": "40px",
    "textAlign": "center",
    "width": "40px"
  };

  const mappedLabel = labelMap(label);

  let ret = <Fragment/>;
  if (percentile > 0) {
    ret = (
      <Col key={label} d-flex className="justify-content-center">
        <Card className="text-center">
          <Card.Body>
            <Card.Title style={titleStyle}>{mappedLabel}</Card.Title>
            <Card.Text style={numberStyle}>{percentile}</Card.Text>
          </Card.Body>
        </Card>
      </Col>
    );
  };
  return ret;
};

const Percentiles = ({ data }) => {

  const clean = (d) => {
    let ret = 0;
    if (d && typeof d === 'number') {
      ret = Math.round(d * 100, 0);
    };
    return ret;
  };

  const globalCategory = data.Global_Category;
  const feePercentile = clean(data.Fee_Percentile);
  const RAR1YearPercentile = clean(data.RAR_1_year_percentile);
  const RelativeRAR1YearPercentile = clean(data.Relative_RAR_1_year_percentile);
  const RAR3YearPercentile = clean(data.RAR_3_year_percentile);
  const RelativeRAR3YearPercentile = clean(data.Relative_RAR_3_year_percentile);
  const RAR5YearPercentile = clean(data.RAR_5_year_percentile);
  const RelativeRAR5YearPercentile = clean(data.Relative_RAR_5_year_percentile);
  const risk5YearPercentile = clean(data._5_Yr_Risk_Percentile);
  const weightedPerformancePercentile = clean(data.Weighted_Performance_Percentile);

  return (
    <div>
      <h3>Peer Comparison (Percentiles)</h3>
      <h6>Peer Category: {globalCategory}</h6>
      <Container>
        <Row xs={2} md={4} className="g-4">
          <PercentileItem label="Fee" percentile={feePercentile} />
          <PercentileItem label="1 Year RAR" percentile={RAR1YearPercentile} />
          <PercentileItem label="Relative 1 Year RAR" percentile={RelativeRAR1YearPercentile} />
          <PercentileItem label="3 Year RAR" percentile={RAR3YearPercentile} />
          <PercentileItem label="Relative 3 Year RAR" percentile={RelativeRAR3YearPercentile} />
          <PercentileItem label="5 Year RAR" percentile={RAR5YearPercentile} />
          <PercentileItem label="Relative 5 Year RAR" percentile={RelativeRAR5YearPercentile} />
          <PercentileItem label="5 Year Risk" percentile={risk5YearPercentile} />
          <PercentileItem label="Weighted Performance" percentile={weightedPerformancePercentile} />
        </Row>
      </Container>
    </div>
  );
};

export default Percentiles;